// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3Qh9G","inputWrap":"CustomTip_inputWrap__1qDBQ"};